interface JQuery {
    serializeObject(): Object;
}

namespace B2B {
    export interface IAppOptions{
        yandexCounterId: string,
        leadUrl: string,
        subscribeUrl: string
    }

    let lang = {
        success: 'Ваша заявка успешно отправлена',
        error: 'Произошла ошибка, попробуйте еще раз',
        name: 'Имя',
        phone: 'Телефон',
        email: 'Email',
        programs: 'Программы',
        requiredError: 'Заполните это поле!',
        emailError: 'Поле Email должно содержать корректный адрес',
        phoneError: 'Укажите корректный номер телефона'
    };

    let fieldError = function (message) {
        if (!$(this).parent().hasClass('feild_wrapper')) {
            $(this).wrap('<div class="feild_wrapper"></div>');
            $(this).parent().append('<span class="error_label"></span>');
        }
        $(this).parent().addClass('wrong');
        $(this).siblings('.error_label').text(message);
        return false;
    }

    let validator = {
        required: function ($i) {
            if ($i.val() == '' || $i.val() == $i.attr('placeholder')) {
                fieldError.call($i, lang.requiredError);

                return false;
            }
            return true;
        },
        email: function ($i) {

            if ($i.val() == '') return true;

            let r = new RegExp(".+@.+\..+", "i");
            if (!r.test($i.val())) {
                fieldError.call($i, lang.emailError);
                return false;
            }
            return true;
        },
        phone: function ($i) {
            var r = new RegExp("([1-9])", "i");
            if (!r.test($i.val())) {
                fieldError.call($i, lang.phoneError);
                return false;
            }
            return true;
        }
    }

    export class App {
        private static _options: IAppOptions;
        private static _gaName: any;

        public static get yandexCounterId(){
            return this._options.yandexCounterId;
        }

        public static get leadUrl(){
            return this._options.leadUrl;
        }

        public static get subscribeUrl(){
            return this._options.subscribeUrl;
        }

        public static init(options: IAppOptions){
            this._options = options;
        }

        public static showError(){
            new B2B.UI.MessagePopup({
                title: "ИЗВИНИТЕ!",
                text: "Сервис временно недоступен, попробуйте повторить позднее."
            }).show();
        }

        public static showThanks(){
            new B2B.UI.MessagePopup({
                title: "СПАСИБО!",
                text: "Ваше обращение уже в работе. Мы свяжемся с Вами!"
            }).show();
        }

        public static showThanksCatalog(){
            new B2B.UI.MessagePopup({
                title: "Розничные\nкаталоги отправлены!",
                text: "К сожалению, вы не авторизовались и\nмы не можем предоставить вам доступ\nк оптовым каталогам.\n\nВы получите розничные каталоги по указанному email.\nПожалуйста, проверьте почту!"
            }).show();
        }

        public static showThanksCatalogOpt(){
            new B2B.UI.MessagePopup({
                title: "Оптовые каталоги отправлены!",
                text: "Вы получите оптовые каталоги по указанному email.\nПожалуйста, проверьте почту!"
            }).show();
        }

        public static showWhatsAppPopup(){
            new B2B.UI.WhatsAppPopup().show().then(r => {});
        }

        public static reachGoal(goalId: string){
            if (goalId && window[App.yandexCounterId]) {
                window[App.yandexCounterId].reachGoal(goalId);
            }
            if (!App._gaName && window["ga"]) {
                window["ga"](function () {
                    // get ga tracker name
                    let trackers = window["ga"].getAll();
                    if (trackers) {
                        App._gaName = trackers[0].get("name");
                    }
                });
            }
            if (goalId && App._gaName) {
                window["ga"](App._gaName + '.send', 'event', 'goals', goalId);
            }
        }

        public static validateForm (form: HTMLFormElement) {
            let $form = $(form);
            let rules = Object();

            let inputs = $form.find('input, select').add('textarea', $form.get(0));

            let validate = true;
            inputs.each(function () {
                let r = $(this).data('rules');
                if (r && r.length != 0) {
                    rules[$(this).attr('name')] = r;
                    r = r.split(',');
                    for (let i = 0; i < r.length; i++) {
                        let rule = r[i];
                        if (validator[rule]) {
                            if (!validator[rule]($(this))) {
                                validate = false;
                            }
                        }
                    }
                }
            });
            return validate;
        }

        public static subscribeCatalog (form: HTMLFormElement): Promise<any> {
            let $form = $(form);

            if (!App.subscribeUrl) {
                throw new Error("App.subscribeUrl must be specified");
            }

            let data = $form.serializeObject();

            return new Promise<any>((onsuccess, onerror) => {
                $.ajax({
                    url: App.subscribeUrl,
                    data: $.extend({}, data, {url: location.protocol + '//' + location.host + location.pathname}),
                    type: 'post',
                    dataType: 'JSON',
                    cache: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (response) {
                        onsuccess(response);
                    },
                    error: function (xhr, status, errorThrown) {
                        onerror(xhr.responseText);
                    }
                });
            });
        }

        public static submitForm(form: HTMLFormElement, additionalData: Object = {}) : Promise<any> {
            let $form = $(form);

            if (!App.leadUrl) {
                throw new Error("App.leadUrl must be specified");
            }

            let goalId = $form.attr("data-goalid");

            let data = $.extend($form.serializeObject(), additionalData);

            return new Promise<any>((onsuccess, onerror) => {
                $.ajax({
                    url: App.leadUrl,
                    data: $.extend({}, data, {url: location.protocol + '//' + location.host + location.pathname}),
                    type: 'post',
                    dataType: 'JSON',
                    cache: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (response) {
                        if (goalId) {
                            App.reachGoal(goalId);
                        }
                        onsuccess(response);
                    },
                    error: function (xhr, status, errorThrown) {
                        onerror(xhr.responseText);
                    }
                });
            });
        }
    }
}

B2B.App.init({
    yandexCounterId: "yaCounter37566000",
    leadUrl: "/mail/mail.php",
    subscribeUrl: "/mail/subscribe.php"
});